import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
    onActionEditar: (idReajuste: number | null, openState: boolean) => void;
    onActionDeletar: (idReajuste: number | null, openState: boolean) => void;

};

export const GenerateReajusteColumns = ({
    onActionEditar,
    onActionDeletar

}: Props):
    GridColDef[] => {

    //#region  mesIndice
    const computeItemMesTitle = (status: number): string => {
        switch (status) {
            case 1: return "Janeiro";
            case 2: return "Fevereiro";
            case 3: return "Março";
            case 4: return "Abril";
            case 5: return "Maio";
            case 6: return "Junho";
            case 7: return "Julho";
            case 8: return "Agosto";
            case 9: return "Setembro";
            case 10: return "Outubro";
            case 11: return "Novembro";
            case 12: return "Dezembro";
            default: return "Mês inválido";
        }
    };

    //#endregion


    return [
        {
            field: "mesIndice",
            filterable: false,
            headerName: "Mês do Índice",
            minWidth: 120,
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        title={computeItemMesTitle(params.value)}
                        color={"blue"}
                        description={""} />
                </div>
            )
        },
        {
            field: "percentual",
            filterable: false,
            headerName: "Percentual",
            minWidth: 50,
            align: 'center',
            sortable: false,
            renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
        },
        {
            field: "dataReajuste",
            filterable: false,
            headerName: "Mês do Reajuste",
            flex: 1,
            minWidth: 130,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    month: "long",
                }).format(new Date(params));
            },
        },
        {
            field: "dataReajusteAno",
            filterable: false,
            headerName: "Ano do Reajuste",
            flex: 1,
            minWidth: 130,
            sortable: false,
            valueGetter: (_, row) => {
                return (row["dataReajuste"]);
            },
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: 'idReajuste',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            width: 100,
            resizable: false,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton
                            onMouseDown={e => onActionEditar(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDeletar(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}